<template>
  <span class="scaling-svg-container">
    <svg
      class="scaling-svg"
      data-name="Icon/Arrow Up"
      xmlns="http://www.w3.org/2000/svg"
      width="12.579"
      height="14.376"
      viewBox="0 0 12.579 14.376"
    >
      <path
        data-name="Icon/Icon/Arrow-up"
        d="M.208,5.966a.9.9,0,0,0,1.265.115L5.391,2.817V13.477a.9.9,0,0,0,1.8,0V2.817l3.917,3.264a.9.9,0,0,0,1.15-1.38L6.864.208a.859.859,0,0,0-.139-.08.825.825,0,0,0-.11-.063.844.844,0,0,0-.652,0,.825.825,0,0,0-.11.063.859.859,0,0,0-.139.08L.323,4.7A.9.9,0,0,0,.208,5.966"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowMoveUpIcon extends Vue {}
</script>

<style>
</style>
